import React from "react";
import CandidateHeader from "./candidateHeader";

const CandidateLayout = ({ children }) => {
  return (
    <>
      <CandidateHeader />
      {children}
    </>
  );
};

export default CandidateLayout;
